import { Styles } from '@monkvision/types';

export const styles: Styles = {
  sightTutorialButton: { padding: '8px' },
};
